export const refinementListTemplate = `
  <label class="ais-RefinementList-label">
    <input type="checkbox" class="ais-RefinementList-checkbox" value="{{value}}" {{#isRefined}}checked{{/isRefined}}>
    <span class="ais-RefinementList-textWrapper">
      <span><span class="ais-RefinementList-labelText">{{highlighted}}</span></span>
      <span class="ais-RefinementList-remove">
        <svg class="ais-RefinementList-removeSymbol" viewBox="0 0 20 20" width="10" height="10"> <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path> </svg>
      </span>
    </span>
    <span class="ais-RefinementList-count">{{count}}</span>
  </label>
`;
